// Vendors + courses from OEM_Top_Courses_by_Vendor.xlsx
// Each vendor has a slug, display name, and courses list.
import { IMAGES } from "./data";

const img = {
    cloud: IMAGES.cloudNetwork,
    ai: IMAGES.aiAbstract,
    data: IMAGES.data,
    cyber: IMAGES.cyber,
    code: IMAGES.coding,
    labs: IMAGES.labs,
    lms: IMAGES.lms,
    dashboard: IMAGES.dashboard,
    workforce: IMAGES.workforce,
    onboarding: IMAGES.onboarding,
    certification: IMAGES.certification,
    trainingRoom: IMAGES.trainingRoom,
    softSkills: IMAGES.softSkills,
    enterpriseTeam: IMAGES.enterpriseTeam,
};

const mkCourses = (arr) =>
    arr.map((name, i) => ({
        id: i + 1,
        title: name,
        duration: "8–12 Weeks",
        certification: "Official OEM Certification",
        audience: "Designed for Tech Professionals",
    }));

export const VENDORS = [
    {
        slug: "aws",
        name: "Amazon Web Services (AWS)",
        tagline: "Cloud, AI & Data Engineering — the world’s most adopted cloud platform.",
        about:
            "Amazon Web Services (AWS) is the world’s most comprehensive and broadly adopted cloud, offering over 200 fully featured services from data centres globally. SpringXE delivers official AWS-aligned enablement — from foundational cloud practitioner tracks to specialty certifications in AI, security, and data — for enterprise cohorts at scale.",
        banner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/xgz4dbof_AWS.jpg",
        courseBanner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/tlhau7p8_AWS.jpg",
        hue: "#FF9900",
        courses: mkCourses([
            "AWS Certified Cloud Practitioner",
            "AWS Certified AI Practitioner",
            "AWS Certified Solutions Architect – Associate",
            "AWS Certified Developer – Associate",
            "AWS Certified SysOps Administrator – Associate",
            "AWS Certified Data Engineer – Associate",
            "AWS Certified Machine Learning Engineer – Associate",
            "AWS Certified Solutions Architect – Professional",
            "AWS Certified DevOps Engineer – Professional",
            "AWS Certified Security – Specialty",
            "AWS Certified Advanced Networking – Specialty",
            "AWS Certified Machine Learning – Specialty",
            "AWS Certified SAP on AWS – Specialty",
            "AWS Cloud Practitioner Essentials",
            "AWS Technical Essentials",
        ]),
    },
    {
        slug: "microsoft",
        name: "Microsoft",
        tagline: "Azure, AI, Data & Modern Work certifications for the enterprise.",
        about:
            "Microsoft powers a huge portion of the modern enterprise stack — from Azure and AI to Power Platform, Dynamics 365 and Microsoft 365. SpringXE runs enterprise-grade Microsoft learning programs aligned with the official Microsoft Certified role-based framework and Applied Skills.",
        banner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/rd2ice61_Microsoft.jpg",
        courseBanner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/70ir1htz_Microsoft.jpg",
        hue: "#00A4EF",
        courses: mkCourses([
            "Microsoft Certified: Azure Fundamentals (AZ-900)",
            "Microsoft Certified: Azure AI Fundamentals (AI-900)",
            "Microsoft Certified: Security, Compliance, and Identity Fundamentals (SC-900)",
            "Microsoft Certified: Azure Administrator Associate (AZ-104)",
            "Microsoft Certified: Azure Developer Associate (AZ-204)",
            "Microsoft Certified: Azure Data Engineer Associate (DP-203)",
            "Microsoft Certified: Power BI Data Analyst Associate (PL-300)",
            "Microsoft Certified: Azure AI Engineer Associate (AI-102)",
            "Microsoft Certified: Azure Security Engineer Associate (AZ-500)",
            "Microsoft Certified: DevOps Engineer Expert (AZ-400)",
            "Microsoft Certified: Azure Solutions Architect Expert (AZ-305)",
            "Microsoft Certified: Power Platform Fundamentals (PL-900)",
            "Microsoft Certified: Dynamics 365 Fundamentals (MB-910)",
            "Microsoft 365 Certified: Fundamentals (MS-900)",
            "Microsoft Applied Skills: Copilot for Microsoft 365",
        ]),
    },
    {
        slug: "gcp",
        name: "Google Cloud Platform (GCP)",
        tagline: "Cloud, Data & GenAI programs from Google Cloud.",
        about:
            "Google Cloud is a market leader in data, AI and cloud-native services. SpringXE partners with the Google Cloud ecosystem to deliver Digital Leader, Associate, Professional and generative AI learning paths aligned with official Google Cloud role-based certifications.",
        banner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/uc4o1vo0_Google%20Cloud.jpg",
        courseBanner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/0mbo76l8_GCP.jpg",
        hue: "#4285F4",
        courses: mkCourses([
            "Google Cloud Digital Leader",
            "Google Cloud Associate Cloud Engineer",
            "Google Cloud Professional Cloud Architect",
            "Google Cloud Professional Data Engineer",
            "Google Cloud Professional Machine Learning Engineer",
            "Google Cloud Professional Cloud Developer",
            "Google Cloud Professional Cloud Security Engineer",
            "Google Cloud Professional Cloud DevOps Engineer",
            "Google Cloud Professional Cloud Network Engineer",
            "Google Cloud Professional Cloud Database Engineer",
            "Google Cloud Generative AI Leader",
            "Google Workspace Administrator (Professional)",
            "Google Cloud Fundamentals: Core Infrastructure",
            "Introduction to Generative AI Learning Path",
        ]),
    },
    {
        slug: "sap",
        name: "SAP",
        tagline: "S/4HANA, SuccessFactors, Ariba, Analytics — enterprise platform enablement.",
        about:
            "SAP powers enterprise processes across finance, supply chain, HR and analytics. SpringXE delivers SAP-aligned enablement across S/4HANA, HANA, SuccessFactors, Ariba, BW/4HANA and Analytics Cloud — for both functional and technical role families.",
        banner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/nwqqqg4q_SAP.jpg",
        courseBanner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/5o45olkj_SAP.jpg",
        hue: "#0FAAFF",
        courses: mkCourses([
            "SAP Certified Associate – SAP S/4HANA Cloud (Public Edition)",
            "SAP Certified Application Associate – SAP S/4HANA for Financial Accounting",
            "SAP Certified Application Associate – SAP S/4HANA Sales",
            "SAP Certified Application Associate – SAP S/4HANA Materials Management",
            "SAP Certified Technology Associate – SAP HANA",
            "SAP Certified Development Associate – ABAP with SAP NetWeaver",
            "SAP Certified Technology Associate – System Administration (SAP S/4HANA)",
            "SAP Certified Application Associate – SAP SuccessFactors Employee Central",
            "SAP Certified Application Associate – SAP Ariba Procurement",
            "SAP Certified Application Associate – SAP BW/4HANA",
            "SAP Certified Application Associate – SAP Analytics Cloud",
            "SAP Certified Application Associate – SAP Extended Warehouse Management",
            "SAP Learning Journey: SAP S/4HANA Overview",
            "SAP Certified Application Associate – SAP Business One",
        ]),
    },
    {
        slug: "redhat",
        name: "Red Hat",
        tagline: "Linux, Ansible, OpenShift and enterprise open source.",
        about:
            "Red Hat is the world’s leading provider of open-source enterprise solutions. SpringXE delivers Red Hat-aligned tracks across RHEL system administration, Ansible automation, OpenShift and Kubernetes, and Red Hat Enterprise Linux AI foundations.",
        banner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/j3qg4sfi_RedHat.jpg",
        courseBanner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/hqfs4x1o_Red%20hat.jpg",
        hue: "#EE0000",
        courses: mkCourses([
            "Red Hat Certified System Administrator (RHCSA)",
            "Red Hat Certified Engineer (RHCE)",
            "Red Hat Certified Architect (RHCA)",
            "Red Hat Certified Specialist in Ansible Automation",
            "Red Hat Certified Specialist in OpenShift Administration",
            "Red Hat Certified Specialist in Containers and Kubernetes",
            "Red Hat Certified Specialist in Security: Linux",
            "Red Hat Certified Specialist in Hybrid Cloud Storage",
            "Red Hat Certified OpenShift Application Developer",
            "Red Hat System Administration I (RH124)",
            "Red Hat System Administration II (RH134)",
            "Red Hat Enterprise Linux Automation with Ansible (RH294)",
            "Red Hat OpenShift Administration I (DO180)",
            "Red Hat Technical Overview of Red Hat Enterprise Linux AI",
        ]),
    },
    {
        slug: "comptia",
        name: "CompTIA",
        tagline: "Vendor-neutral IT & cybersecurity certifications.",
        about:
            "CompTIA offers vendor-neutral certifications that validate foundational IT and cybersecurity skills across infrastructure, networking, cloud and security. SpringXE runs CompTIA-aligned enablement across the A+ through CASP+ (SecurityX) stack.",
        banner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/aiua3a8x_CompTia.jpg",
        courseBanner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/boy9e3wa_Comptia.jpg",
        hue: "#C8202F",
        courses: mkCourses([
            "CompTIA A+", "CompTIA Network+", "CompTIA Security+", "CompTIA Linux+",
            "CompTIA Cloud+", "CompTIA Server+", "CompTIA PenTest+",
            "CompTIA CySA+ (Cybersecurity Analyst)", "CompTIA CASP+ (SecurityX)",
            "CompTIA Data+", "CompTIA Project+", "CompTIA ITF+ (IT Fundamentals)", "CompTIA Cloud Essentials+",
        ]),
    },
    {
        slug: "istqb",
        name: "ISTQB",
        tagline: "ISTQB Software Testing certifications, worldwide standard.",
        about:
            "ISTQB (International Software Testing Qualifications Board), delivered through PeopleCert, stewards globally recognised software testing certifications. SpringXE delivers ISTQB-aligned tracks from Foundation Level through Advanced, Expert and Specialist streams — including AI, Security and Performance testing.",
        banner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/j39s79u0_ISTQB.jpg",
        courseBanner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/wkbz0smd_ISTQB.jpg",
        hue: "#0091DA",
        courses: mkCourses([
            "ISTQB Certified Tester Foundation Level (CTFL)",
            "ISTQB Certified Tester Foundation Level – Agile Tester (CTFL-AT)",
            "ISTQB Advanced Level Test Analyst (CTAL-TA)",
            "ISTQB Advanced Level Technical Test Analyst (CTAL-TTA)",
            "ISTQB Advanced Level Test Manager (CTAL-TM)",
            "ISTQB Advanced Level Test Automation Engineering (CTAL-TAE)",
            "ISTQB Specialist – Performance Testing (CT-PT)",
            "ISTQB Specialist – Usability Testing (CT-UT)",
            "ISTQB Specialist – Mobile Application Testing (CT-MAT)",
            "ISTQB Specialist – AI Testing (CT-AI)",
            "ISTQB Specialist – Security Tester (CT-SEC)",
            "ISTQB Expert Level Test Management (CTEL-TM)",
            "ISTQB Specialist – Game Testing (CT-GaMe)",
        ]),
    },
    {
        slug: "scrum-alliance",
        name: "Scrum Alliance",
        tagline: "Agile, Scrum and leadership certifications.",
        about:
            "Scrum Alliance is the world’s largest and longest-established professional community for agilists. SpringXE runs the full Scrum Alliance journey — from CSM/CSPO foundations through advanced and enterprise coaching credentials.",
        banner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/t4runc6d_ScrumAlliance.jpg",
        courseBanner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/ibmg9q9u_Scrum%20Alliance.jpg",
        hue: "#EF6C00",
        courses: mkCourses([
            "Certified ScrumMaster (CSM)",
            "Certified Scrum Product Owner (CSPO)",
            "Certified Scrum Developer (CSD)",
            "Advanced Certified ScrumMaster (A-CSM)",
            "Advanced Certified Scrum Product Owner (A-CSPO)",
            "Certified Scrum Professional – ScrumMaster (CSP-SM)",
            "Certified Scrum Professional – Product Owner (CSP-PO)",
            "Certified Agile Leadership I (CAL I)",
            "Certified Agile Leadership II (CAL II)",
            "Certified Enterprise Coach (CEC)",
            "Certified Team Coach (CTC)",
            "Scrum Alliance Agile Coaching Skills Certified Facilitator",
        ]),
    },
    {
        slug: "ascm",
        name: "ASCM – Supply Chain Management",
        tagline: "Global supply chain, logistics and operations certifications.",
        about:
            "ASCM (Association for Supply Chain Management) is the largest non-profit for supply chain professionals worldwide. SpringXE delivers ASCM-aligned CPIM, CSCP, CLTD and SCOR-P tracks plus foundational supply chain fundamentals.",
        banner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/klfbjky6_ASCM.jpg",
        courseBanner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/6zenpz4c_ASCM.jpg",
        hue: "#0091DA",
        courses: mkCourses([
            "Certified in Production and Inventory Management (CPIM)",
            "Certified Supply Chain Professional (CSCP)",
            "Certified in Logistics, Transportation and Distribution (CLTD)",
            "SCOR-Professional (SCOR-P)",
            "Certified Transformation for Supply Chain (CTSC)",
            "APICS CPIM Part 1: Basics of Supply Chain Management",
            "APICS CPIM Part 2: Supply Chain Management Execution and Control",
            "Global Supply Chain Fundamentals",
            "Demand Planning and Sales & Operations Planning (S&OP)",
            "Lean and Six Sigma for Supply Chain",
            "Supply Chain Risk Management",
            "Procurement and Sourcing Fundamentals",
        ]),
    },
    {
        slug: "ibm",
        name: "IBM",
        tagline: "Watsonx, Cloud, Data & Enterprise Systems certifications.",
        about:
            "IBM offers foundational and advanced enterprise certifications across watsonx, Cloud Pak, Db2, WebSphere, Cognos and cybersecurity. SpringXE runs IBM-aligned programs for AI Engineering, Data Engineering, Full-Stack, Cybersecurity Analyst and Z Mainframe streams.",
        banner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/e33zqt98_IBM.jpg",
        courseBanner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/pcktcpj6_IBM.jpg",
        hue: "#1F70C1",
        courses: mkCourses([
            "IBM Certified Specialist – Db2 Database Administration",
            "IBM Certified System Administrator – WebSphere",
            "IBM Certified Analyst – Cognos Analytics",
            "IBM Cybersecurity Analyst Professional Certificate",
            "IBM Certified Associate – IBM Cloud Pak for Data",
            "IBM Certified Data Engineer",
            "IBM DevOps and Software Engineering Professional Certificate",
            "IBM Certified Specialist – IBM Z Mainframe",
            "IBM AI Engineering Professional Certificate",
            "IBM Full Stack Software Developer Professional Certificate",
        ]),
    },
    {
        slug: "github",
        name: "GitHub",
        tagline: "Developer platform certifications — from Actions to Copilot.",
        about:
            "GitHub is the world’s largest developer platform. SpringXE runs GitHub-aligned enablement across Foundations, Actions, Administration, Advanced Security, Codespaces and Copilot certifications.",
        banner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/530z0khs_GitHub.jpg",
        courseBanner: img.code,
        hue: "#FFFFFF",
        courses: mkCourses([
            "GitHub Foundations", "GitHub Actions Certification", "GitHub Administration Certification",
            "GitHub Advanced Security Certification", "GitHub Copilot Certification",
            "GitHub Codespaces Certification", "Introduction to GitHub",
            "Managing Merge Conflicts on GitHub", "GitHub Project Management", "Git and GitHub for DevOps",
        ]),
    },
    {
        slug: "elastic",
        name: "Elastic",
        tagline: "Elasticsearch, Observability and Security certifications.",
        about:
            "Elastic is the search AI company — powering search, observability and security use cases at scale. SpringXE delivers Elastic Certified Engineer, Analyst and Observability Engineer credentials plus foundational stack training.",
        banner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/g645m4gh_Elastic.jpg",
        courseBanner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/kdbs4sn3_Elastic.jpg",
        hue: "#00BFB3",
        courses: mkCourses([
            "Elastic Certified Engineer", "Elastic Certified Analyst",
            "Elastic Certified Observability Engineer", "Elasticsearch Engineer I",
            "Elasticsearch Engineer II", "Elastic Stack Fundamentals",
            "Kibana Data Analysis", "Elastic Security Fundamentals",
            "Advanced Elasticsearch Performance Tuning",
        ]),
    },
    {
        slug: "lightbend",
        name: "Lightbend",
        tagline: "Reactive Architecture, Akka & Scala for distributed systems.",
        about:
            "Lightbend’s Reactive Architecture curriculum is a definitive learning path for engineers building distributed, resilient, event-driven systems using Akka and Scala. SpringXE delivers these tracks for platform and reactive systems teams.",
        banner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/voxy139m_Lightbend.jpg",
        courseBanner: img.labs,
        hue: "#4F86FF",
        courses: mkCourses([
            "Reactive Architecture: Introduction to Reactive Systems",
            "Reactive Architecture: Domain Driven Design",
            "Reactive Architecture: Foundations of Akka",
            "Reactive Architecture: CQRS & Event Sourcing",
            "Programming Reactive Systems (Scala & Akka)",
            "Functional Program Design in Scala",
            "Akka Streams Fundamentals",
            "Akka Cluster and Distributed Systems",
        ]),
    },
    {
        slug: "mirantis",
        name: "Mirantis",
        tagline: "Kubernetes, OpenStack and cloud-native platforms.",
        about:
            "Mirantis provides open-cloud infrastructure powering some of the largest Kubernetes and OpenStack deployments in the world. SpringXE runs Mirantis-aligned platform administration tracks for enterprise cloud-native teams.",
        banner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/pqi4d00v_Mirantis.jpg",
        courseBanner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/9rd8isx7_Mirantis.jpg",
        hue: "#00A9E0",
        courses: mkCourses([
            "Mirantis Kubernetes Engine (MKE) Administration",
            "Mirantis OpenStack Cloud Administration",
            "Mirantis Secure Registry (MSR) Fundamentals",
            "Mirantis Container Cloud Operations",
            "Mirantis k0s Kubernetes Fundamentals",
            "Mirantis Cloud Native Platform Administration",
            "Introduction to Mirantis OpenStack for Kubernetes",
        ]),
    },
    {
        slug: "isc2",
        name: "ISC2",
        tagline: "CISSP, CCSP and the global gold standard of cybersecurity credentials.",
        about:
            "ISC2 is the world’s leading cybersecurity professional organisation and steward of the CISSP, CCSP and CC certifications. SpringXE delivers ISC2-aligned readiness programs across foundations, associate and expert-level tracks.",
        banner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/pp5044g4_ISC2.jpg",
        courseBanner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/qqj7q0g6_ISC2.jpg",
        hue: "#7DB343",
        courses: mkCourses([
            "ISC2 Certified in Cybersecurity (CC)",
            "Certified Information Systems Security Professional (CISSP)",
            "Certified Cloud Security Professional (CCSP)",
            "Systems Security Certified Practitioner (SSCP)",
            "Certified Secure Software Lifecycle Professional (CSSLP)",
            "Certified in Governance, Risk and Compliance (CGRC)",
            "CISSP Concentration – Architecture (ISSAP)",
            "CISSP Concentration – Engineering (ISSEP)",
            "CISSP Concentration – Management (ISSMP)",
            "HCISPP – Healthcare Information Security and Privacy Practitioner",
        ]),
    },
    {
        slug: "check-point",
        name: "Check Point",
        tagline: "Network, endpoint and cloud security certifications.",
        about:
            "Check Point Software Technologies is a global leader in cybersecurity solutions. SpringXE runs the full Check Point certification ladder — from CCSA and CCSE foundations through Maestro, Harmony, VSX and multi-domain specialist tracks.",
        banner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/o0m8e752_CheckPoint.jpg",
        courseBanner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/3rlyzvfw_Check%20Point.jpg",
        hue: "#E51F19",
        courses: mkCourses([
            "Check Point Certified Security Administrator (CCSA)",
            "Check Point Certified Security Expert (CCSE)",
            "Check Point Certified Security Master (CCSM)",
            "Check Point Certified Troubleshooting Administrator (CCTA)",
            "Check Point Certified Troubleshooting Expert (CCTE)",
            "Check Point Certified Maestro Expert (CCME)",
            "Check Point Certified Harmony Endpoint Specialist (CCES)",
            "Check Point Certified Cloud Specialist (CCCS)",
            "Check Point VSX Specialist (CCVS)",
            "Check Point Certified Multi-Domain Security Management Specialist (CCMS)",
            "Check Point Certified Automation Specialist (CCAS)",
        ]),
    },
    {
        slug: "csa",
        name: "Cloud Security Alliance (CSA)",
        tagline: "Cloud security, zero trust and cloud governance credentials.",
        about:
            "The Cloud Security Alliance is the world’s leading authority on cloud security best practices. SpringXE delivers CSA-aligned CCSK, CCAK, CCZT and cloud governance tracks for security and audit teams.",
        banner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/ck90h51i_CSA.jpg",
        courseBanner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/pn8wc6si_CSA.jpg",
        hue: "#0A5CFF",
        courses: mkCourses([
            "Certificate of Cloud Security Knowledge (CCSK)",
            "Certificate of Cloud Auditing Knowledge (CCAK)",
            "CSA STAR Program Auditor Training",
            "Cloud Governance and GRC Fundamentals",
            "Zero Trust Advancement Certificate (CCZT)",
            "AI Safety and Governance for Cloud (CSA)",
            "Cloud Threat Modeling",
        ]),
    },
    {
        slug: "snowflake",
        name: "Snowflake",
        tagline: "The AI Data Cloud — SnowPro certifications end-to-end.",
        about:
            "Snowflake’s AI Data Cloud powers modern data platforms across the world’s largest enterprises. SpringXE delivers the SnowPro certification ladder — Core through Advanced Architect, Data Engineer, Data Analyst and Data Scientist streams.",
        banner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/tgvqkpoo_Snowflake.jpg",
        courseBanner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/gpl59ho0_Snowflake.jpg",
        hue: "#29B5E8",
        courses: mkCourses([
            "SnowPro Core Certification",
            "SnowPro Advanced Architect",
            "SnowPro Advanced Data Engineer",
            "SnowPro Advanced Data Analyst",
            "SnowPro Advanced Data Scientist",
            "SnowPro Advanced Administrator",
            "Snowflake Fundamentals (Hands-on Essentials)",
            "Snowflake for Generative AI",
            "Snowflake Data Governance Fundamentals",
            "Snowflake Performance Optimization",
            "Snowflake Snowpark Developer Fundamentals",
        ]),
    },
    {
        slug: "broadcom",
        name: "Broadcom",
        tagline: "VMware virtualisation, NSX, vSAN and enterprise infrastructure.",
        about:
            "Broadcom (VMware) powers the world’s largest private cloud and virtualisation footprints. SpringXE runs the VCP, VCAP and VCDX certification ladder plus NSX, vSAN, Horizon and Cloud Foundation enablement.",
        banner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/6ll9fms6_Broadcom.jpg",
        courseBanner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/ubtbcu6p_Broadcom.jpg",
        hue: "#CC092F",
        courses: mkCourses([
            "VMware Certified Professional – Data Center Virtualization (VCP-DCV)",
            "VMware Certified Advanced Professional – Data Center Virtualization Design (VCAP-DCV Design)",
            "VMware Certified Design Expert (VCDX)",
            "VMware Certified Professional – Network Virtualization (NSX)",
            "VMware Certified Professional – Desktop and Mobility (Horizon)",
            "VMware vSphere: Install, Configure, Manage [V8]",
            "VMware vSAN: Deploy and Manage",
            "VMware NSX-T Data Center: Install, Configure, Manage",
            "VMware Cloud Foundation: Deploy and Manage",
            "Symantec (Broadcom) Endpoint Security Complete Administration",
            "Broadcom Certified Specialist – Mainframe Software",
        ]),
    },
    {
        slug: "dell-emc",
        name: "Dell EMC",
        tagline: "Storage, data protection and enterprise infrastructure certifications.",
        about:
            "Dell Technologies delivers a comprehensive infrastructure portfolio spanning storage, cloud, server, networking and data protection. SpringXE runs Dell Technologies Proven Professional-aligned tracks from Associate through Expert and Master.",
        banner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/6eglj7ov_DELL%20EMC.jpg",
        courseBanner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/jgmnlsb5_Dell%20EMC.jpg",
        hue: "#007DB8",
        courses: mkCourses([
            "Dell Technologies Certified Associate – Information Storage and Management",
            "Dell Technologies Certified Associate – Cloud Infrastructure and Services",
            "Dell Technologies Certified Specialist – Data Protection",
            "Dell Technologies Certified Specialist – PowerStore",
            "Dell Technologies Certified Specialist – PowerEdge Server",
            "Dell Technologies Certified Expert – Data Protection",
            "Dell Technologies Certified Master – Cloud Architect",
            "Dell EMC Networking Certified Associate",
            "Dell Technologies Proven Professional – Converged Systems",
            "Dell Technologies Certified Associate – Networking",
        ]),
    },
    {
        slug: "mulesoft",
        name: "MuleSoft",
        tagline: "Integration, API-led connectivity and Anypoint Platform certifications.",
        about:
            "MuleSoft, a Salesforce company, powers API-led connectivity for the world’s largest enterprises. SpringXE delivers MuleSoft-aligned Developer, Architect and Integration Associate/Professional tracks.",
        banner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/sfkbq1ty_MuleSoft.jpg",
        courseBanner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/iipbz6aj_Mulesoft.jpg",
        hue: "#00A0DF",
        courses: mkCourses([
            "MuleSoft Certified Developer – Integration and API Associate (Mule 4)",
            "MuleSoft Certified Developer – Integration Professional (Mule 4)",
            "MuleSoft Certified Platform Architect – Integration",
            "MuleSoft Certified Integration Architect",
            "MuleSoft Certified API Designer",
            "Anypoint Platform Development: Fundamentals",
            "MuleSoft Certified Developer – Level 2",
            "MuleSoft Certified Catalyst Associate",
            "Anypoint Platform Operations: Advanced",
        ]),
    },
    {
        slug: "chef",
        name: "Chef",
        tagline: "Configuration management, compliance and DevOps automation.",
        about:
            "Chef (Progress) provides configuration management and continuous compliance for the modern enterprise. SpringXE delivers Chef Infra, Habitat, InSpec and Automate learning paths for platform engineering teams.",
        banner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/p4ggk2bv_Chef.jpg",
        courseBanner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/neiu7456_CHEF.jpg",
        hue: "#F09820",
        courses: mkCourses([
            "Chef Certified Developer", "Chef Fundamentals", "Chef Infra Foundations",
            "Chef Automate Compliance", "Chef Habitat Foundations", "Chef InSpec Foundations",
            "Chef Courier Foundations", "Progress Chef: Configuration Management Essentials",
        ]),
    },
    {
        slug: "siemens",
        name: "Siemens",
        tagline: "Industrial automation, Digital Industries & smart manufacturing.",
        about:
            "Siemens is the global leader in industrial automation and digitalisation. SpringXE runs Siemens-aligned enablement across TIA Portal, SIMATIC, MindSphere and Digital Twin — for engineering, manufacturing and IIoT teams.",
        banner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/hr00mbgm_SIEMENS.jpg",
        courseBanner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/lqzjr1ja_Siemnes.jpg",
        hue: "#009999",
        courses: mkCourses([
            "Siemens TIA Portal Basics", "SIMATIC S7-1200 Programming",
            "SIMATIC S7-1500 Advanced Programming", "Siemens PLC Networking & Communication",
            "Siemens WinCC SCADA Fundamentals", "Siemens Safety Integrated",
            "MindSphere IIoT Fundamentals", "Siemens Digital Twin & Simulation",
            "Siemens NX CAD Essentials", "Siemens Teamcenter PLM Foundations",
            "Siemens Motion Control (SINAMICS)", "Siemens Industrial Edge Foundations",
        ]),
    },
    {
        slug: "blockchain-training-alliance",
        name: "Blockchain Training Alliance",
        tagline: "Vendor-neutral blockchain, Web3 & smart contract certifications.",
        about:
            "Blockchain Training Alliance (BTA) provides globally-recognised, vendor-neutral blockchain credentials. SpringXE delivers BTA-aligned tracks for architects, developers, security engineers and business leaders across Ethereum, Hyperledger and Corda ecosystems.",
        banner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/thahkc2k_Blockchain%20Training%20Alliance.jpg",
        courseBanner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/j2gu3xgf_Block%20Chain.jpg",
        hue: "#F7931A",
        courses: mkCourses([
            "Certified Blockchain Business Foundations (CBBF)",
            "Certified Blockchain Solution Architect (CBSA)",
            "Certified Blockchain Developer – Ethereum (CBDE)",
            "Certified Blockchain Developer – Hyperledger (CBDH)",
            "Certified Blockchain Security Professional (CBSP)",
            "Certified Blockchain Solutions Developer",
            "Certified Blockchain Business Professional",
            "Enterprise Blockchain Professional",
            "Blockchain for Executives",
            "Smart Contract Development on Ethereum",
            "Blockchain for Supply Chain",
        ]),
    },
    {
        slug: "android-atc",
        name: "Android ATC",
        tagline: "Official Android developer & security certifications.",
        about:
            "Android ATC (Android Authorised Training Center) issues official Android developer certifications recognised worldwide. SpringXE delivers ATC-aligned tracks from app foundations to advanced security and Kotlin engineering.",
        banner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/1g18k1dv_Android%20ATC.jpg",
        courseBanner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/ameizmvc_Android.jpg",
        hue: "#3DDC84",
        courses: mkCourses([
            "Android Certified Application Developer (AAD)",
            "Android Certified Application Engineer (ACAE)",
            "Android Security Essentials",
            "Monetise Android Applications",
            "Android Enterprise Application Development",
            "Kotlin for Android Developers",
            "Android Jetpack & Modern App Architecture",
            "Android UI/UX with Material Design",
            "Publishing to Google Play – Best Practices",
        ]),
    },
    {
        slug: "pecb",
        name: "PECB",
        tagline: "ISO management-systems auditor & implementer certifications.",
        about:
            "PECB is a global certification body for ISO management-system standards across information security, business continuity, quality, and privacy. SpringXE delivers PECB-aligned Lead Implementer and Lead Auditor programs for governance, risk and compliance teams.",
        banner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/wlam6xjp_PECB.jpg",
        courseBanner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/5f73c55d_PECB.jpg",
        hue: "#0F4C81",
        courses: mkCourses([
            "ISO/IEC 27001 Lead Implementer",
            "ISO/IEC 27001 Lead Auditor",
            "ISO/IEC 27005 Risk Manager",
            "ISO/IEC 27032 Lead Cybersecurity Manager",
            "ISO/IEC 27701 Lead Implementer",
            "ISO 22301 Lead Implementer (Business Continuity)",
            "ISO 22301 Lead Auditor",
            "ISO 9001 Lead Implementer (Quality)",
            "ISO 9001 Lead Auditor",
            "ISO 31000 Risk Manager",
            "ISO/IEC 20000 Lead Implementer (IT Service Mgmt)",
            "ISO 37301 Lead Implementer (Compliance)",
            "ISO 42001 Lead Implementer (AI Management)",
            "GDPR Certified Data Protection Officer",
        ]),
    },
    {
        slug: "oracle",
        name: "Oracle",
        tagline: "Oracle Database, Cloud Infrastructure (OCI) & Java certifications.",
        about:
            "Oracle offers deeply respected certifications across database, cloud infrastructure, Java, and enterprise applications. SpringXE runs Oracle-aligned learning across OCI Architect, DBA, Java SE 17 Developer, and Fusion Cloud Applications.",
        banner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/jvu4kyk6_ORACLE.jpg",
        courseBanner: "https://customer-assets.emergentagent.com/job_future-workforce-9/artifacts/1yt28mqi_Oracal.jpg",
        hue: "#F80000",
        courses: mkCourses([
            "Oracle Certified Associate – Java SE 17 Developer",
            "Oracle Certified Professional – Java SE 17 Developer",
            "Oracle Cloud Infrastructure Foundations (OCI)",
            "Oracle Cloud Infrastructure Architect Associate",
            "Oracle Cloud Infrastructure Architect Professional",
            "Oracle Cloud Infrastructure Developer Associate",
            "Oracle Cloud Infrastructure DevOps Professional",
            "Oracle Cloud Data Management Foundations",
            "Oracle Database SQL Certified Associate",
            "Oracle Database Administrator Certified Professional",
            "Oracle Autonomous Database Specialist",
            "Oracle Fusion Cloud Applications – ERP Foundations",
            "Oracle Cloud Infrastructure AI Foundations",
        ]),
    },
];

export const vendorBySlug = (slug) => VENDORS.find((v) => v.slug === slug);

// Official brand logos — served from /public/logos/. Every partner has a real logo file.
export const LOGOS = {
    "aws": "/logos/aws.svg",
    "microsoft": "/logos/microsoft.svg",
    "gcp": "/logos/gcp.svg",
    "sap": "/logos/sap.svg",
    "redhat": "/logos/redhat.svg",
    "comptia": "/logos/comptia.svg",
    "istqb": "/logos/istqb.svg",
    "scrum-alliance": "/logos/scrum-alliance.svg",
    "ascm": "/logos/ascm.svg",
    "siemens": "/logos/siemens.svg",
    "blockchain-training-alliance": "/logos/blockchain-training-alliance.svg",
    "android-atc": "/logos/android.svg",
    "pecb": "/logos/pecb.svg",
    "oracle": "/logos/oracle.svg",
    "ibm": "/logos/ibm.svg",
    "dell-emc": "/logos/dell-emc.svg",
    "mulesoft": "/logos/mulesoft.svg",
    "chef": "/logos/chef.svg",
    "github": "/logos/github.svg",
    "elastic": "/logos/elastic.svg",
    "lightbend": "/logos/lightbend.svg",
    "mirantis": "/logos/mirantis.svg",
    "isc2": "/logos/isc2.svg",
    "check-point": "/logos/check-point.svg",
    "csa": "/logos/csa.svg",
    "snowflake": "/logos/snowflake.svg",
    "broadcom": "/logos/broadcom.svg",
};

// Display order matching the user-provided course-count master list.
const ORDER = [
    "aws", "microsoft", "gcp", "sap", "redhat", "comptia", "istqb",
    "scrum-alliance", "ascm", "siemens", "blockchain-training-alliance",
    "android-atc", "pecb", "oracle", "ibm", "dell-emc", "mulesoft", "chef",
    "github", "elastic", "lightbend", "mirantis", "isc2", "check-point",
    "csa", "snowflake", "broadcom",
];

export const ORDERED_VENDORS = ORDER
    .map((slug) => VENDORS.find((v) => v.slug === slug))
    .filter(Boolean);
